import { render, staticRenderFns } from "./TilledCardList.vue?vue&type=template&id=f2d54b6a"
import script from "./TilledCardList.vue?vue&type=script&lang=js"
export * from "./TilledCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports